import React, { Component } from 'react';
import { loadMenu } from "../../api"
import {Link} from 'react-router-dom';

class NavBar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            menuJson: "",
            data: {},
            navClose: { right: '0px' }
        }
    }

    onMouseEnterHandler() {
        if (window.innerWidth > 1199) {
            document.querySelector("#main-menu").classList.add("hover-unset");
        }
    }

    handleSubmenu = (event) => {
        const t = event.target;
        if (t.classList.contains('sub-arrow'))
            return;
        const next = t.nextElementSibling;

        if (next) {
            if(next.classList.contains('opensubmenu'))
                next.classList.remove('opensubmenu')
            else{
                document.querySelectorAll('.nav-submenu').forEach(function (value) {
                    value.classList.remove('opensubmenu');
                });
                next.classList.add('opensubmenu')
            }
        } else {
            this.props.closeNav()
        }
    }

    createLink = (item) => {
        return (
            <Link to={`${process.env.PUBLIC_URL}${item.link?item.link:"#"}`} className="nav-link" onClick={(e) => this.handleSubmenu(e)}>
                {item.name}
                {item.menu
                ?   <span className="sub-arrow"></span>
                :   null
                }
            </Link>
        )

    }

    createMenu = () => {
        let parent = [];
        this.state.menuJson.forEach((item, index) => {
          parent.push(<li key={index}>
            {this.createLink(item)}
            {item.child?
            <ul className="nav-submenu">
                {item.child.map((subitem, subIndex) => {
                    return (<li key={subIndex}>{this.createLink(subitem)}</li>)
                })}
            </ul>
            :null}
        </li>);
        });
        return parent;
    }

    loadMenu = () => {
        this.setState({ loading: true});
        if (this.props.pid) {
            loadMenu(this.props.pid).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    this.setState({ data: d2, menuJson: JSON.parse(d2.menuJson), loading: false});                    
                }
            });
        } else this.setState({ loading: false});
    };

    componentDidMount() {
        if (window.innerWidth < 750) {
            this.setState({ navClose: { right: '-410px' } })
        }

        this.loadMenu();        

    }

    componentDidUpdate(prevProps) {
        if(prevProps.cartChange !== this.props.cartChange) {
            this.loadMenu();
        }
        if(prevProps.navClose !== this.props.navClose) {
            this.setState({navClose: this.props.navClose })
        }
    }

    render() {
        if (this.state.loading) { return null; }
        else return (
            <div>
                <div className="main-navbar">
                    <div id="mainnav" >
                        <ul className="nav-menu" style={this.state.navClose}>
                            <li className="back-btn" onClick={this.props.closeNav} >
                                <div className="mobile-back text-right">
                                    <span >Back</span>
                                    <i className="fa fa-angle-right pl-2" aria-hidden="true"></i>
                                </div>
                            </li>
                            {this.createMenu()}
                        </ul>
                    </div>
                </div>
            </div>
        )
    }
}


export default NavBar;